import React, { useCallback } from 'react';
import { Modal, ModalFooter, ModalHeader } from 'reactstrap';

import Button from '~components/Button';

import { CompanyAccessKey } from '~main/models';

import { useRevokeCompanyAccessKeyMutation } from '~main/actions/companyAccessKeys';

interface ComponentProps {
  isOpen: boolean;
  reset: () => void;
  row?: Partial<CompanyAccessKey>;
}

const ConfirmDeleteModal: React.FC<ComponentProps> = ({ isOpen, reset, row }) => {
  const [revokeToken, { isLoading: isRevoking }] = useRevokeCompanyAccessKeyMutation();
  const { name } = row || {};

  const handleConfirmDelete = useCallback(async () => {
    const id = row?.id;
    if (!id) return;
    const { data } = await revokeToken({ id });
    if (data?.success) reset();
  }, [row, revokeToken]);
  return (
    <Modal isOpen={isOpen} toggle={reset}>
      <ModalHeader className="bg-danger text-white">Confirm Revoke - {name}</ModalHeader>
      <div className="p-3">
        <div>Are you sure you want to revoke this key?</div>
        <div className="fw-bold mt-1 text-danger">This action is irreversible!</div>
      </div>
      <ModalFooter>
        <Button color="danger" disabled={isRevoking} onClick={handleConfirmDelete}>
          {isRevoking ? 'Revoking...' : 'Revoke'}
        </Button>
        <Button color="secondary" onClick={reset} disabled={isRevoking}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDeleteModal;
